import type { operations } from '../analyst/types'
import analystDataList from '../../data/analystData.json'

export class analystService {
  async getAnalistInfo(
    status: number[] | null,
    operationType: number | null,
    operationAccepted: Array<number> | null = null,
    dateTime: [Date, Date] | null = null, // cambio aquí
  ): Promise<{ data: operations[] }> {
    const filteredOperations = analystDataList.data
      .filter((analyst: any) => {
        const analystCurrentTypeId = analyst.operationType
        const analystStatusId = analyst.status?.id

        // Filtro por operationAccepted
        if (operationAccepted && operationAccepted.length > 0) {
          if (!operationAccepted.includes(analystStatusId)) {
            return false
          }
        }

        // Filtro por status
        if (status && status.length > 0 && !status.includes(analystStatusId)) {
          return false
        }

        // Filtro por operationType
        if (operationType !== undefined && operationType !== null) {
          if (analystCurrentTypeId !== operationType) {
            return false
          }
        }

        // Filtro por fecha

        if (dateTime && (dateTime[0] || dateTime[1])) {
          const firstDate = dateTime[0] ? new Date(dateTime[0]) : null
          const secondDate = dateTime[1] ? new Date(dateTime[1]) : null

          // Si solo hay una fecha válida, usarla como el rango del día completo
          const start = new Date(
            firstDate!.getFullYear(),
            firstDate!.getMonth(),
            firstDate!.getDate(),
            0,
            0,
            0,
            0,
          )
          const end = secondDate
            ? new Date(
                secondDate.getFullYear(),
                secondDate.getMonth(),
                secondDate.getDate(),
                23,
                59,
                59,
                999,
              )
            : new Date(
                firstDate!.getFullYear(),
                firstDate!.getMonth(),
                firstDate!.getDate(),
                23,
                59,
                59,
                999,
              )

          // Normalizar formato con `/` → `-` para evitar problemas con Date()
          const dateString = analyst.dateTime.replace(/\//g, '-')
          const analystDate = new Date(dateString)

          if (isNaN(analystDate.getTime()) || analystDate < start || analystDate > end) {
            return false
          }
        }

        return true
      })
      .map((analyst: any) => ({
        ...analyst,
      }))

    return { data: filteredOperations }
  }
}
